<div class="mobile-menu-overlay" role="presentation" (click)="closed.emit()">
  <div
    class="mobile-menu-drawer"
    role="dialog"
    aria-modal="true"
    aria-label="Menu principal"
    (click)="$event.stopPropagation()"
  >
    <header class="mobile-menu-header">
      <strong>Menu</strong>
      <button type="button" aria-label="Cerrar menu principal" (click)="closed.emit()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </header>

    <app-sidebar-menu
      [profile]="profile"
      [irrigatorParcelsPanelVisible]="irrigatorParcelsPanelVisible"
      [irrigatorParcels]="irrigatorParcels"
      [irrigatorParcelsLoading]="irrigatorParcelsLoading"
      [irrigatorParcelsError]="irrigatorParcelsError"
      [selectedIrrigatorParcelId]="selectedIrrigatorParcelId"
      [guardTakesPanelVisible]="guardTakesPanelVisible"
      [guardTakes]="guardTakes"
      [guardTakesLoading]="guardTakesLoading"
      [guardTakesError]="guardTakesError"
      [selectedGuardTakeId]="selectedGuardTakeId"
      [guardFieldOperationsView]="guardFieldOperationsView"
      [incidentsSummaryVisible]="incidentsSummaryVisible"
      [maintenanceSummaryVisible]="maintenanceSummaryVisible"
      [publicInfoVisible]="publicInfoVisible"
      [aboutRamVisible]="aboutRamVisible"
      (informationToggled)="toggleInformation()"
      (aboutRequested)="showAbout()"
      (irrigatorParcelsPanelToggled)="toggleIrrigatorParcelsPanel()"
      (irrigatorParcelSelected)="selectIrrigatorParcel($event)"
      (guardTakesPanelToggled)="toggleGuardTakesPanel()"
      (guardTakeSelected)="selectGuardTake($event)"
      (guardFieldOperationsRequested)="showGuardFieldOperations($event)"
      (logoutRequested)="logout($event)"
    ></app-sidebar-menu>
  </div>
</div>
